import logger from '../logger'

export interface ReduxCachedState {
  cacheParam?: string
}

export const createCacheParam = (actionType: string, actionCreatorName: string, actionCreatorParam: object): string => {
  const cacheParam = { ...actionCreatorParam }
  delete cacheParam['curState']
  return JSON.stringify({
    __actionType__: actionType,
    __actionCreator__: actionCreatorName,
    ...cacheParam,
  })
}

export const isCacheHit = (state: object, cacheParam: string) => {
  if (!state.hasOwnProperty('cacheParam')) {
    logger.warn("Current redux state has to have 'cacheParam' property when redux cache is used")
    return false
  }
  if (!state['cacheParam'] || !cacheParam) {
    return false
  }
  return state['cacheParam'] === cacheParam
}
